import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IRetrieveDownloadPanelStyles {
  root?: IStyle;
}

export interface IRetrieveDownloadPanelClassNames {
  root: string;
}

export const retrieveDownloadPanelStylesDefault = (_theme: IH2OTheme): Partial<IRetrieveDownloadPanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
